import { apiDomain as api, apiKey } from '../appConfig';

const getDLRCD = async () =>
	fetch(`${api}/SCWS/Service.asmx/GETDLRCD`, {
		method: 'POST',
		// body: data,
		headers: {
			'Content-Type': 'application/x-www-form-urlencoded',
			'Ocp-Apim-Subscription-Key': apiKey,
		},
	})
		.then((res) => res.json())
		.catch((err) => console.error(err));

export default getDLRCD;



// WEBPACK FOOTER //
// ./src/js/fetch/getDLRCD.js